import { render, staticRenderFns } from "./editDeparture.vue?vue&type=template&id=125b5e85&scoped=true"
import script from "./editDeparture.vue?vue&type=script&lang=js"
export * from "./editDeparture.vue?vue&type=script&lang=js"
import style0 from "./editDeparture.vue?vue&type=style&index=0&id=125b5e85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125b5e85",
  null
  
)

export default component.exports